!function($, window, document) {
    const $win = $(window), $body = ($(document), $(document.body)), $header = ($(".js-sticky-aside"), 
    $(".header")), $footer = $(".footer");
    let winHeight = $win.innerHeight(), headerHeight = $header.outerHeight() ? $header.outerHeight() : 0, footerHeight = $footer.outerHeight() ? $footer.outerHeight() : 0, winScrollTop = $win.scrollTop();
    const stickyAside = () => $(".js-sticky-aside").each(((index, parent) => {
        let $parent = $(parent);
        const noHeader = $parent.hasClass("sticky-aside--no-header"), parentOffsetTop = $parent.offset().top, parentHeight = $parent.outerHeight(), parentWidth = $parent.outerWidth(), $child = $parent.find(".sticky-item"), contentHeight = $child.find("h2").outerHeight(), childHeight = $child.outerHeight(), lastColMarginBottom = ($child.outerWidth(), 
        parseInt($child.closest(".row").find(".js-col").last().css("margin-bottom")));
        noHeader && (headerHeight = 0), $(window).outerWidth() <= 768 && $child.closest("section").css("padding-bottom", contentHeight + 30);
        const sectionBottomPadding = parseInt($child.closest("section").css("padding-bottom"));
        $parent.closest("section").css({
            "--parent-width": parentWidth + "px",
            "--child-height": childHeight + "px",
            "--content-height": contentHeight + "px",
            "--sticky-offset-top": headerHeight + "px",
            "--last-margin-bottom": lastColMarginBottom + "px",
            "--section-bottom-padding": sectionBottomPadding + "px"
        });
        let isSticky = winScrollTop + headerHeight >= parentOffsetTop, isStickyBottom = parentOffsetTop + parentHeight - lastColMarginBottom <= winScrollTop + headerHeight + childHeight - $(window).outerHeight() / 2 + contentHeight / 2;
        $(window).outerWidth() <= 768 && (isSticky = winScrollTop + headerHeight >= parentOffsetTop, 
        isStickyBottom = parentOffsetTop + parentHeight - lastColMarginBottom <= winScrollTop + headerHeight + childHeight - 30), 
        $parent.toggleClass("is-sticky", isSticky).toggleClass("is-sticky-bottom", isStickyBottom);
    })), stickyForm = () => $(".js-sticky-form").each(((index, parent) => {
        let $parent = $(parent);
        const noHeader = $parent.hasClass("sticky-aside--no-header"), parentOffsetTop = $parent.offset().top, parentHeight = $parent.outerHeight(), parentWidth = $parent.outerWidth(), $child = $parent.find(".sticky-item"), childHeight = $child.outerHeight();
        $child.outerWidth();
        noHeader && (headerHeight = 0), $parent.css({
            "--parent-width": parentWidth + "px",
            "--child-height": childHeight + "px",
            "--sticky-offset-top": headerHeight + "px"
        });
        const isSticky = winScrollTop + headerHeight >= parentOffsetTop, isStickyBottom = parentOffsetTop + parentHeight <= winScrollTop + headerHeight + childHeight;
        $parent.toggleClass("is-sticky", isSticky).toggleClass("is-sticky-bottom", isStickyBottom);
    }));
    function scrollToHashTarget(hash, duration = 1e3) {
        if (!hash || "#" === hash) return !1;
        const targetId = decodeURIComponent(hash.substring(1)), $target = $("#" + CSS.escape(targetId));
        if (!$target.length) return !1;
        const position = $target.offset().top;
        return $("html, body").animate({
            scrollTop: position
        }, duration), !0;
    }
    $(".js-mobile-accordion-trigger").on("click", (function(e) {
        e.preventDefault(), $(this).toggleClass("is-active"), $(this).parent().find(".js-accordion-body").slideToggle().parent(), 
        $(this).parent().find(".slick-slider").slick("setPosition");
    })), $(".js-accordion-features li").on("click", (function(e) {
        e.preventDefault(), $(this).toggleClass("is-active"), $(this).find("p").slideToggle();
    })), $(document).on("click", 'a[href*="#"]', (function(e) {
        const href = $(this).attr("href");
        if (!href || "#" === href) return;
        const hash = function getLinkHash(href) {
            if (!href || "#" === href) return "";
            const hashIndex = href.indexOf("#");
            return -1 === hashIndex ? "" : href.substring(hashIndex);
        }(href);
        hash && function isSamePageAnchor(href) {
            if (!href || "#" === href) return !1;
            const link = document.createElement("a");
            link.href = href;
            const currentPath = window.location.pathname.replace(/\/$/, ""), linkPath = (link.pathname || "").replace(/\/$/, ""), currentHost = window.location.host, linkHost = link.host || currentHost;
            return link.hash && linkHost === currentHost && linkPath === currentPath;
        }(href) && $(hash).length && (e.preventDefault(), scrollToHashTarget(hash));
    })), $(window).on("load", (function() {
        const hash = window.location.hash;
        hash && $(hash).length && scrollToHashTarget(hash, 1e3);
    })), $(".nav-trigger").on("click", (e => {
        e.preventDefault(), $body.toggleClass("is-menu-expanded");
    })), $(".nav a").on("click", (e => {
        $body.removeClass("is-menu-expanded");
    }));
    const lenis = new Lenis;
    requestAnimationFrame((function raf(time) {
        lenis.raf(time), requestAnimationFrame(raf);
    })), $win.on("load", (e => {
        $body.addClass("is-loaded");
        const $sectionRegister = $(".section-register");
        new ResizeObserver((entries => {
            entries.forEach((entry => {
                $sectionRegister.parents(".section-register-holder").css("--form-height", $sectionRegister.outerHeight() + "px");
            }));
        })).observe($sectionRegister[0]), setTimeout((() => {
            $body.addClass("start-hero-logo");
        }), 2800), setTimeout((() => {
            stickyAside(), stickyForm();
        }), 400);
    })).on("load scroll resize", (() => {
        winHeight = $win.innerHeight(), headerHeight = $header.outerHeight() ? $header.outerHeight() : 0, 
        footerHeight = $footer.outerHeight() ? $footer.outerHeight() : 0, winScrollTop = $win.scrollTop(), 
        $body.css({
            "--header-height": headerHeight + "px",
            "--footer-height": footerHeight + "px"
        }), stickyAside(), stickyForm(), $body.hasClass("is-loaded") && $(".js-animate").each(((index, element) => {
            let $this = $(element), animateStart = $this.attr("data-start");
            $this.offset().top + $this.outerHeight() * animateStart < $win.scrollTop() + $win.outerHeight() && $this.addClass("is-animated");
        }));
    })), setInterval((function updateTime() {
        let now = new Date, options = {
            timeZone: $(".js-current-time").data("timezone"),
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: !1
        }, timeString = now.toLocaleTimeString("en-US", options);
        $(".js-current-time").text(timeString);
    }), 1e3), jQuery(document).on("gform_confirmation_loaded", (function(event, formId) {
        $win.outerWidth() < 1024 && setTimeout((() => {
            var position = $(".section-register").offset().top;
            $("body, html").animate({
                scrollTop: position
            }, 300);
        }), 150);
    }));
}(jQuery, window, document);